// extracted by mini-css-extract-plugin
export default {"sectionTitle":"CreateOrganizationModal_sectionTitle__A37Cz","toggleRow":"CreateOrganizationModal_toggleRow__ZxIiT"};